<template>
  <div>
    <img v-for="(img,i) in images" :src="img" alt="" ondragstart="return false;" class="responsive"
         :key="i">
  </div>
</template>

<script>
export default {
  name: "ImageList",
  props: {images: {type: Array}}
}
</script>

<style scoped>
.responsive {
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
